import jmespath from 'jmespath'
import { get, isEmpty, map } from 'lodash'
import { getBoundingBoxData } from 'map-style'
import { MS_UUID } from 'map-style-utils'
import { useEffect } from 'react'
import {
  clearHighlightIds,
  setFilterResults,
  setHighlightIds,
  useFilters
} from '~map-filter-view/states/filter'
import { setBounds, useJsonFeatures } from '~map-preview/states/map'
import { store } from '~map-preview/states/store'
import { QueryBuilder } from './QueryBuilder'

export const useFilterSelectionSet = () => {
  const jsonFeatures = useJsonFeatures()
  const filters = useFilters()

  useEffect(() => {
    if (isEmpty(jsonFeatures)) return

    performingFiltersOnMapFeatures(filters, jsonFeatures)
  }, [filters])

  return []
}

const performingFiltersOnMapFeatures = (filters, features) => {
  const hasFilters = filters.length

  if (!hasFilters) {
    clearFilterResults()
    adjustFitBounds(features)
    return
  }

  const filterResults = getFilterResult(features, filters)

  // INFO: Dispatch fitBounds cause map to zooms and pans to the extent of filterResults
  adjustFitBounds(filterResults)
  highlightFilterSelectionSet(filterResults)
  displayFilterResults(filterResults)
}

const highlightFilterSelectionSet = (filterResults) => {
  store.dispatch(
    setHighlightIds(
      map(filterResults, (item) => get(item?.properties, MS_UUID))
    )
  )
}

const displayFilterResults = (filterResults) => {
  store.dispatch(setFilterResults(filterResults))
}

const clearFilterResults = () => {
  store.dispatch(clearHighlightIds())
  store.dispatch(setFilterResults([]))
}

const getFilterResult = (features, filters) => {
  const query = QueryBuilder.create(filters)
  const results = jmespath.search(features, query)
  return results
}

const adjustFitBounds = (results) => {
  const bounds = getBoundingBoxData({
    type: 'FeatureCollection',
    features: results
  })

  store.dispatch(setBounds(bounds))
}
